import React from 'react';
import styled from 'styled-components';
import DefaultCloseButton from './closeButton';
import { Header as DefaultHeader } from './header';

interface IHeaderProps {
    backgroundColor?: string;
}

const Header = styled(DefaultHeader)<IHeaderProps>`
    ${({ backgroundColor }): string => backgroundColor && `background: ${backgroundColor};`}
`;

const CloseButton = styled(DefaultCloseButton)`
    display: flex;
    justify-content: flex-end;
`;

interface IDefaultHeaderProps {
    className?: string;
    userCanClose?: boolean;
    close?: () => void;
    backgroundColor?: string;
    alternativeCloseText?: string;
}

export default ({
    className,
    userCanClose,
    close,
    backgroundColor = null,
    alternativeCloseText = null
}: IDefaultHeaderProps): JSX.Element => (
    <Header className={className} backgroundColor={backgroundColor}>
        {userCanClose && <CloseButton onClick={close} alternativeCloseText={alternativeCloseText} />}
    </Header>
);
